export const queryKeys = {
  environmentOverview: (environmentKey: string) => ['environment-overview', environmentKey],
}
